import * as t from 'io-ts';

export enum LiveStreamCampaignStatus {
  READY = 'READY',
  REHEARSAL = 'REHEARSAL',
  ONAIR = 'ONAIR',
  ENDED = 'ENDED',
}

export const LiveStreamCampaignStatusEnum = t.keyof({
  [LiveStreamCampaignStatus.READY]: null,
  [LiveStreamCampaignStatus.REHEARSAL]: null,
  [LiveStreamCampaignStatus.ONAIR]: null,
  [LiveStreamCampaignStatus.ENDED]: null,
});
